import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import * as CoreActions from 'core/duck';
import * as staffActions from 'features/staff-and-rooms/duck';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import { SimpleModal, RoomTimer } from 'shared/components';
import { NotificationsPreview } from 'features/notifications';
import { requirePersonalInformation } from 'shared/helpers';
import { getPersonnelRoles } from 'shared/selectors';
import './Navbar.scss';
import ProfileBox from './ProfileBox';
import DoubleArrows from 'assets/svgs/doubleArrows.svg';
import http from '../../../core/services/http';
import Config from 'core/config';

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: this.props.users[0] || {},
      dropToggled: false,
      logOutConfirm: false,
      scrollHeight: 0,
      nowLink: '',
    };

    this.handleDropClick = this.handleDropClick.bind(this);
    this.logOutUser = this.logOutUser.bind(this);
    this.logOutUserConfirm = this.logOutUserConfirm.bind(this);
    this.navigateToNow = this.navigateToNow.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, false);
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false);
  }

  componentDidUpdate(prevProps) {
    const { currentUser, tcEventStaff, personnelRoles, tcCycle } = this.props;

    if (this.props.tcEvent.id && this.props.tcEvent.id !== prevProps.tcEvent.id) {
      if (tcEventStaff.length === 0) {
        this.props.coreActions.getTcEventStaff(this.props.tcEvent.id);
      }
      if (isEmpty(tcCycle)) {
        this.props.coreActions.getTestCenterCycle(this.props.tcEvent.id);
      }
    }

    if (
      this.props.tcCycle.testCenterProgram?.testCenter.nowManagedFlag &&
      (this.props.tcCycle.testCenterProgram?.testCenter.nowManagedFlag !==
        prevProps.tcCycle.testCenterProgram?.testCenter.nowManagedFlag ||
        this.props.tcEventStaff !== prevProps.tcEventStaff)
    ) {
      const testCenterCoordinator =
        currentUser.testCenterCyclePersonnels && tcCycle
          ? currentUser.testCenterCyclePersonnels.find(
              (item) => item.testCenterCycleId === tcCycle.id
            )
          : {};
      const coordinator = tcEventStaff
        ? tcEventStaff.find(
            (pers) =>
              pers.personnelId === currentUser.id &&
              (pers.roleName === personnelRoles.TEST_DAY_COORDINATOR ||
                pers.roleName === personnelRoles.COORDINATOR ||
                pers.roleName === personnelRoles.SYSTEM_READINESS ||
                testCenterCoordinator?.role?.role === personnelRoles.COORDINATOR)
          )
        : {};
      if (!isEmpty(coordinator)) {
        http
          .get(`${Config.apiUrl}/testcenterevent/${this.props.tcEvent.id}/orgpart`)
          .then((response) => {
            this.setState({
              nowLink: response[0],
            });
          });
      }
    }
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }

  getCurrentUser() {
    if (this.state.currentUser.id) {
      return this.state.currentUser;
    }

    return this.props.users[0] || {};
  }

  handleDropClick(e) {
    if (e && e.type === 'keyup' && e.keyCode !== 13) {
      return;
    }
    this.setState((prevState) => ({
      dropToggled: !prevState.dropToggled,
    }));
  }

  logOutUserConfirm(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState((prevState) => ({
      logOutConfirm: !prevState.logOutConfirm,
    }));
  }

  logOutUser() {
    this.props.coreActions.logoutUser().then(() => {
      this.setState({
        logOutConfirm: false,
      });
    });
  }

  onScroll = () => {
    if (document.documentElement.scrollTop > 2) {
      this.setState({
        scrollHeight: document.documentElement.scrollHeight,
      });
    } else {
      this.setState({
        scrollHeight: 0,
      });
    }
  };
  navigateToNow = () => {
    const host = window.location.hostname.replace('tcm', 'now');
    window.location.href = `https://${host}/landingPage/orgPartId/${this.state.nowLink}`;
  };

  render() {
    const { currentUser, tcEventStaff, personnelRoles, tcCycle } = this.props;
    const currentPath = window.location.pathname;
    const isPersonalBackgroundInfoPage = currentPath === '/profile/personal-background-info';
    const hasSwitchToNow =
      currentPath.includes('test-event') || currentPath.includes('irregularities');
    const testCenterCoordinator =
      currentUser.testCenterCyclePersonnels && tcCycle
        ? currentUser.testCenterCyclePersonnels.find(
            (item) => item.testCenterCycleId === tcCycle.id
          )
        : {};
    const coordinator = tcEventStaff
      ? tcEventStaff.find(
          (pers) =>
            pers.personnelId === currentUser.id &&
            (pers.roleName === personnelRoles.TEST_DAY_COORDINATOR ||
              pers.roleName === personnelRoles.COORDINATOR ||
              pers.roleName === personnelRoles.SYSTEM_READINESS ||
              testCenterCoordinator?.role?.role === personnelRoles.COORDINATOR)
        )
      : {};

    return (
      <div className={`${this.state.scrollHeight ? 'stiky' : ''} navigation`}>
        <div className="container">
          <nav className="navbar p-0 justify-content-between">
            <div className="logo-container">
              <a className={`${isPersonalBackgroundInfoPage} navbar-brand`} href="/dashboard">
                <img src="/src/assets/svgs/logo.svg" alt="ACT Logo" />
              </a>
              {hasSwitchToNow &&
                !isEmpty(coordinator) &&
                tcCycle.testCenterProgram?.testCenter.nowManagedFlag && (
                  <div className="switch-container">
                    <div className="separator"></div>
                    <div
                      onClick={this.navigateToNow}
                      className="switch-logo"
                      tabIndex="0"
                      data-bs-toggle="popover"
                      data-bs-placement="bottom"
                      data-bs-trigger="hover"
                      data-bs-content={this.props.t('navigation.switchToAct')}>
                      <DoubleArrows />
                      <span>{this.props.t('navigation.actNow')}</span>
                    </div>
                  </div>
                )}
            </div>
            {!isEmpty(currentUser) && (
              <div className="icon-container">
                {!requirePersonalInformation(currentUser) && !isPersonalBackgroundInfoPage && (
                  <React.Fragment>
                    <div className="profile-container">
                      <NotificationsPreview />
                    </div>
                    <ProfileBox userInfo={currentUser} logOutFunction={this.logOutUserConfirm} />
                  </React.Fragment>
                )}
              </div>
            )}
          </nav>
        </div>
        <div
          className={`container-timer ${
            hasSwitchToNow &&
            !isEmpty(coordinator) &&
            tcCycle.testCenterProgram?.testCenter.nowManagedFlag &&
            'switch-timer'
          }`}>
          {currentPath.indexOf('online-testing') === -1 && <RoomTimer location={currentPath} />}
        </div>
        <SimpleModal
          isOpen={this.state.logOutConfirm}
          onCancel={this.logOutUserConfirm}
          onConfirm={this.logOutUser}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('profile.logOutQuestion')}
        />
      </div>
    );
  }
}

Navbar.propTypes = {
  // Props from mapStateToProps
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.number,
    testCenterCyclePersonnels: PropTypes.arrayOf(
      PropTypes.shape({
        testCenterCycleId: PropTypes.number,
        role: PropTypes.shape({
          role: PropTypes.string,
        }),
      })
    ),
  }),
  tcCycle: PropTypes.shape({
    id: PropTypes.number,
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        nowManagedFlag: PropTypes.bool,
      }),
    }),
  }),
  tcEventStaff: PropTypes.arrayOf(
    PropTypes.shape({
      personnelId: PropTypes.number,
      roleName: PropTypes.string,
    })
  ),
  personnelRoles: PropTypes.object,
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
  }),

  // Props from mapDispatchToProps
  coreActions: PropTypes.shape({
    getTcEventStaff: PropTypes.func.isRequired,
    getTestCenterCycle: PropTypes.func.isRequired,
    logoutUser: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    users: state.users.length ? state.users : [],
    currentUser: state.users.currentUser,
    tcCycle: state.tcEvent.testCenterCycle,
    tcEventStaff: state.staff.tcEventStaff,
    personnelRoles: getPersonnelRoles(state),
    tcEvent: state.tcEvent.currentEvent,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    coreActions: bindActionCreators(
      { ...CoreActions, ...staffActions, ...tcEventActions },
      dispatch
    ),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Navbar));
